import React from 'react';
import { Card, Segmented, Space, Typography, Alert } from 'antd';
import {
	PlayCircleOutlined,
	PictureOutlined,
	SwitcherOutlined,
	ClockCircleOutlined,
	InfoCircleOutlined,
} from '@ant-design/icons';

const { Title, Text } = Typography;

/**
 * InstagramContentTypeCard
 * - Fully independent, all logic encapsulated
 * - Mobile-first responsive layout; desktop stays tidy
 * - Logic parity:
 *    -- Choose between stories, reels and carousel for Instagram
 *    -- Render currently selected post type
 *    -- Post type is set in the parent component and then sent to the backend
 */

const InstagramContentTypeCard = ({ postType, setPostType }) => {
	const availablePostTypes = [
		{
			label: 'Carousel',
			value: 'Carousel',
			icon: <SwitcherOutlined />,
			description: 'Multiple images/videos in one post',
		},
		{
			label: 'Reels',
			value: 'Reels',
			icon: <PlayCircleOutlined />,
			description: 'Short engaging videos',
		},
		{
			label: 'Stories',
			value: 'Stories',
			icon: <ClockCircleOutlined />,
			description: 'Vertical videos/images (24h)',
		},
	];

	const handlePostTypeChange = (value) => {
		setPostType(value);
	};

	const getPostTypeDetails = (type) => {
		return availablePostTypes.find((item) => item.value === type);
	};

	const currentSelection = getPostTypeDetails(postType);

	return (
		<Card
			size="small"
			title={
				<Space>
					<PictureOutlined />
					<Text strong>Instagram Content Type</Text>
				</Space>
			}
			style={{
				width: '100%',
				margin: '0 auto',
			}}
			extra={<Text type="secondary">Required</Text>}
		>
			<Space direction="vertical" style={{ width: '100%' }} size="middle">
				{/* Segmented Control */}
				<Segmented
					options={availablePostTypes}
					value={postType}
					onChange={handlePostTypeChange}
					size="large"
					block
					style={{
						width: '100%',
						justifyContent: 'stretch',
					}}
				/>

				{/* Selection Details */}
				{currentSelection && (
					<Alert
						message={
							<Space direction="vertical" size="small">
								<Text strong>{currentSelection.label} Selected</Text>
								<Text type="secondary" style={{ fontSize: '12px' }}>
									{currentSelection.description}
								</Text>
							</Space>
						}
						type="info"
						showIcon
						icon={<InfoCircleOutlined />}
						style={{
							background: 'transparent',
							border: '1px solid #d0d0d0',
						}}
					/>
				)}

				{/* Quick Stats */}
				<div
					style={{
						display: 'flex',
						justifyContent: 'space-between',
						padding: '8px 0',
						borderTop: '1px solid #f0f0f0',
					}}
				>
					<Text type="secondary" style={{ fontSize: '12px' }}>
						Aspect Ratio:
						<Text strong>{postType === 'Stories' || postType === 'Reels' ? ' 9:16' : ' 1:1'}</Text>
					</Text>
					<Text type="secondary" style={{ fontSize: '12px' }}>
						Duration:
						<Text strong>
							{postType === 'Reels'
								? ' 90s max'
								: postType === 'Stories'
								? ' 15s max'
								: ' Flexible'}
						</Text>
					</Text>
				</div>
			</Space>
		</Card>
	);
};

export default InstagramContentTypeCard;
